import { render, staticRenderFns } from "./MyPoints.vue?vue&type=template&id=48f79831&"
import script from "./MyPoints.js?vue&type=script&lang=js&"
export * from "./MyPoints.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports